import React from "react";
import Balances1 from "./child/Balances1";
import BalanceLimit1 from "./child/BalanceLimit1";
import TradingFrequency1 from "./child/Tradingfrequency1";
const DashBoardLayerOne = () => {
  return (
    <>
      <section>
        <div className="row gy-4 mt-4">
          <Balances1 />
          {/* <BalanceLimit1 />
          <TradingFrequency1 /> */}
        </div>
      </section>
    </>
  );
};

export default DashBoardLayerOne;
